export enum ROLE_ACTIONS {
    ALLOWED = 'Allowed',
    READ = 'Read',
    UPDATE = 'Update',
    CREATE = 'Create',
    DELETE = 'Delete'
}

export enum AdminBackendPermissionNames {
    DEVICE = 'Device',
    AGENTS = 'ACDAgent',
    DIRECTORY = 'DirectoryEntry',
    USER = 'User',
    CODE = 'Code',
    TEL_SYS = 'TelSys',
    PARTITION = 'Partition',
    RECORDING = 'Recording',
    CME = 'CME',
    MESSAGE = 'Message',
    DATABASE = 'Database',
    USER_ROLE = 'UserRole',
    CRM_CONFIG = 'CrmConfig',

    LOG_MGMT = 'LogMngmt',
    CALL_CONTROL = 'CallControl',
    LICENCE = 'License',
    LOGGING = 'Logging',
    AUDIT_TRAIL = 'AuditTrail',
    TEL_SYS_STATUS = 'TelSysStatus',
    SERVER_STATUS = 'ServerStatus',

    COPY_REPORTS_TO = 'ReportCopy',
    SIGN_IN_AS = 'SignInAs',
    BILLING_FILES_DOWNLOAD = 'BillingCDRs',
    BILLING_SUMMARY = 'BillingSummary',
    CHANGE_TELSYS_BILLABLE = 'ChangeTelSysBillable',
    CHANGE_LICENCE_LEVEL = 'ChangeTelSysPartitionLicenseLevel',
    SYNC_PARTITION = 'SyncPartition',
    EPT_ACCESS = 'EPTAccess',
    LOG_FILES_DOWNLOAD = 'LogFilesDownload',
    TELSYS_SYNC_RESTRICTIONS = 'TelSysSyncRestrictions',

    CME_BRANDING_CONFIG = 'CMEBrandingConfig',

    EDIT_OWN_CME_DOMAIN_PROFILE = 'EditOwnCMEDomainProfile',
    EDIT_OWN_CME_BRANDING = 'EditOwnCMEBrandingConfig',
    EDIT_OWN_CME_PROVISIONING = 'EditOwnCMEProvisioning',

    INTEGRATOR_CLIENT = 'IntegratorClient'
}

// Backend permission names.
export enum BackendPermissionNames {
    REPORTING_API = 'ReportDataAPI',
    ENHANCED_FEATURES = 'AdvancedMobileAppFeatures',
    CONCURRENT_SIGNINS = 'ConcurrentSignIn',
    SERVICE_NOTIFICATION = 'ServiceNotifications',
    REPORT_TEMPLATE_USER = 'ReportTemplateUser',
    AUTH_NOTIFICATIONS = 'AuthNotifications',
    NEW_DEVICE_NOTIFICATIONS = 'NewDevicesAddedNotifications',
    TELSYS_SYNC_RESTRICTIONS = 'TelSysSyncRestrictions'
}
